import DbBaseObject from "@shared/DbBaseObject.js";

export default class BaseToolResult extends DbBaseObject {
	toolType: string = ""
	toolInstanceId: string = ""
	ownerId: string = ""
	teamMemberId: string = null
	clientId: string = ""
	clientName: string = ""
	resultThreadId: string = ""
	participationSessionId: string = ""
	participationAssignmentId: string = ""
	enginePayload: any = null
	submissionConsent: any = null

	summary: any = null
	journalEntryId: string = ""
	freeReviewUnlockedAt: number = null

	constructor(options = {}) {
		super(options);
		this.applyOptions(options)
	}
}
